import { List } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledModifiersList = styled(List)({
  display: 'grid',
  gridTemplateColumns: '960px',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Open Sans'
});

export const StyledModifiersListItem = styled('div')(({ index }: { index: number }) => ({
  display: 'flex',
  gridRowStart: index + 1
}));
